import React from 'react'

import {usePriceWatchToggleLogic} from '../../hooks/usePriceWatchToggleLogic'
import {PriceWatchCTAParams} from '../../types'

export const PriceWatchCTA = (props: PriceWatchCTAParams) => {
  const {handleClick, isToggleOn} = usePriceWatchToggleLogic(props)
  if (!props?.rate?.base) return null

  const {ctaComponent: CtaComponent, shouldPulse, hideIcon} = props

  if (!CtaComponent) return null
  return (
    <CtaComponent
      className={props.className}
      isToggleOn={isToggleOn}
      handleClick={handleClick}
      shouldPulse={shouldPulse}
      hideIcon={hideIcon}
      hasAlertText={props.hasAlertText}
    />
  )
}
